import React from "react";

const UnreadEmptyIcon = ({ color = "black" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66699 11.333H4.30033C5.05449 11.333 5.43199 11.333 5.76366 11.4855C6.09533 11.638 6.34033 11.9247 6.83116 12.4972L7.33616 13.0855C7.82699 13.658 8.07199 13.9447 8.40366 14.0972C8.73533 14.2497 9.11199 14.2497 9.86699 14.2497H10.1337C10.8878 14.2497 11.2653 14.2497 11.597 14.0972C11.9287 13.9447 12.1737 13.658 12.6645 13.0855L13.1695 12.4972C13.6603 11.9247 13.9053 11.638 14.237 11.4855C14.5687 11.333 14.9453 11.333 15.7003 11.333H18.3337"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M1.66699 10.4998C1.66699 14.4282 1.66699 16.3923 2.88699 17.6123C4.10866 18.8332 6.07199 18.8332 10.0003 18.8332C13.9287 18.8332 15.8928 18.8332 17.1128 17.6123C18.3337 16.3932 18.3337 14.4282 18.3337 10.4998C18.3342 9.90039 18.3328 9.34484 18.3295 8.83317M11.667 2.17067C11.1553 2.16789 10.5998 2.1665 10.0003 2.1665C6.07199 2.1665 4.10783 2.1665 2.88699 3.3865C2.07616 4.19817 1.80366 5.339 1.71283 7.1665"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M18.334 10.4998C18.334 14.4282 18.334 16.3923 17.114 17.6123C15.8923 18.8332 13.929 18.8332 10.0007 18.8332C6.07232 18.8332 4.10815 18.8332 2.88815 17.6123C1.66732 16.3932 1.66732 14.4282 1.66732 10.4998C1.66676 9.90039 1.66815 9.34484 1.67148 8.83317M8.33398 2.17067C8.84565 2.16789 9.40121 2.1665 10.0007 2.1665C13.929 2.1665 15.8932 2.1665 17.114 3.3865C17.9248 4.19817 18.1973 5.339 18.2882 7.1665"
        stroke={color}
        stroke-linecap="round"
      />
    </svg>
  );
};

export default UnreadEmptyIcon;
